import { Box, Modal, Typography } from "@mui/material";
import AppButton from "./AppButton";
import DeleteIcon from "../../assets/icon/trash.svg";
import CancelIcon from "../../assets/icon/cross.svg";
import { styles } from "./BlockModelStyles";

const BlockModel = ({
  open,
  onClose,
  currentName,
  onBlock,
  heading,
  subheading,
  blockText,
  staffItem,
}: any) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={styles.modalBox}>
        {/* Close button at the top-right */}
        <Box onClick={onClose} sx={styles.closeButton}>
          <img src={CancelIcon} alt="Close" style={styles.cancelIcon}/>
        </Box>

        {/* Main content */}
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          {/* Left: Circle with bin icon */}
          <Box sx={styles.iconContainer}>
            <img src={DeleteIcon} alt="Delete" style={styles.deleteIcon} />
          </Box>

          {/* Text content */}
          <Box sx={{ flex: 1 }}>
            <Typography
              id="modal-title"
              variant="h6"
              component="h2"
              sx={styles.title}
            >
              {heading
                ? heading
                : `${
                    !staffItem?.isActive ? "Unblock" : "Block"
                  } ${currentName}`}
            </Typography>
            <Typography id="modal-description" sx={styles.description}>
              {subheading
                ? subheading
                : `Are you sure you want to ${
                    !staffItem?.isActive ? "Unblock" : "Block"
                  } this Member?`}
            </Typography>
          </Box>
        </Box>

        {/* Buttons */}
        <Box sx={styles.buttonContainer}>
          <AppButton
            onClick={onClose}
            title="Cancel"
            sx={styles.cancelButton}
          />
          <AppButton
            onClick={onBlock}
            title={
              blockText ? blockText : !staffItem?.isActive ? "Unblock" : "Block"
            }
            sx={styles.blockButton}
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default BlockModel;
